/* eslint-disable max-len */
import React from 'react';

const NewDownloadIcon: React.FC = (): React.JSX.Element => {
	return (
		<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M3.49766 0.799805C3.82903 0.799805 4.09766 1.06843 4.09766 1.3998V9.0903L5.8734 7.3146C6.1077 7.08029 6.4876 7.08029 6.7219 7.3146C6.9562 7.54892 6.9562 7.92882 6.7219 8.16313L3.92192 10.9631C3.68761 11.1974 3.30771 11.1974 3.07339 10.9631C3.04625 10.936 2.91851 10.8304 2.89766 10.7998L0.273389 8.14829C0.0390787 7.91397 0.0390787 7.53407 0.273389 7.29976C0.507709 7.06545 0.887609 7.06545 1.12192 7.29976L2.89766 9.0755V1.3998C2.89766 1.06843 3.16629 0.799805 3.49766 0.799805Z" fill="#3377FA"/>
		</svg>         
	);
};

export default NewDownloadIcon;